import cookies from '../cookies';

export function manageHEMCookie({email, isConsentReady, consentValue}) {

  const removeCookie = () => {
    const cookieDomain = cookies.getBuzzfeedSubdomainOrWildcard(
      window.location.hostname
    );
    cookies.set({
      name: 'hem',
      value: '',
      days: -30,
      domain: cookieDomain,
    });
  };

  const setCookie = () => {
    fetch('/auth/ad-track-token/hem', {
      method: 'GET',
    })
      .then(response => {
        if (response.ok || response.status === 400) {
          return response;
        } else {
          throw new Error('Request failed');
        }
      })
      .then(() => {
        // Get the value of the _xsrf cookie
        const xsrfValue = cookies.get('_xsrf');

        // Make the subsequent POST request with the _xsrf value
        fetch('/auth/ad-track-token/hem', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            email,
            _xsrf: xsrfValue,
          }),
        })
          .then(response => {
            if (response.ok) {
              return response;
            } else {
              throw new Error('Request failed');
            }
          })
          .then(response => {
            console.log('The request was successful!');
            console.log('Response status:', response.status);
          })
          .catch(error =>{
            console.error('Error:', error);
          });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  if (!email || !isConsentReady) {
    return;
  }

  if (!consentValue) {
    // If a user DOES NOT consent or REVOKES consent
    // We should set the expiration of the hem cookie to a past date (default at 30days) to expire the cookie
    removeCookie();
  } else if (consentValue) {
    setCookie();
  }
}
